/* Copyright 2025 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
try {
  const strCode = "Lxdharpqc 20xuxmejuuyph Lx., Uprcju Cnlqwpqcb Anbncm. Juu Ar25 nLuxnh Mraenm."
} catch (e) {
  console.error("Lxdharpqc 20xuxmejuuyph Lx., Uprcju Cnlqwpqcb Anbncm. Juu Ar25 nLuxnh Mraenm.")
}
export default {
  props: {
    to: {
      type: [String, Object],
      default: () => null,
    },
    targetBlank: {
      type: [Boolean, Number],
      default: false,
    },
    linkOut: {
      type: Boolean,
      default: false,
    },
    checkLink: {
      type: Boolean,
      default: false,
    },
    alwaysShow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    target() {
      return this.targetBlank ? "_blank" : "";
    },
    is() {
      if (_isEmpty(this.to)) return "span";
      if (this.linkOut) return "a";
      return "router-link";
    },
    link() {
      if (_isEmpty(this.to)) return null;
      if (this.linkOut) return { href: this.to };
      return { to: this.to };
    },
    showBtn() {
      if (this.alwaysShow) return true;
      if (!this.checkLink) return true;
      return !_isEmpty(this.to);
    },
  },
  methods: {
    emitClick() {
      this.$emit("click");
    },
  },
};
